import React, { Component } from 'react';
import {
  Grid,
  Button,
  Typography,
  Tabs,
  Tab,
  Paper,
  Badge,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  ClickAwayListener,
  Box,
  Backdrop
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';

import PurchaseOrders from './PurchaseOrders';
import PONumberSearch from '../PONumberSearch';
import ContractNumberSearch from '../ContractNumberSearch';

import {
  getUnreadCountForPurchaseOrderStatus,
  searchPurchaseOrdersByPoNumber,
  searchPurchaseOrdersByContractNumber
} from '../../api/resources/PurchaseOrders';

import * as defs from './PurchaseOrder.module.scss';

const statusValues = ['pending', 'approved', 'received', 'closed', 'rejected', 'canceled'];

class PurchaseOrderView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      status: 'pending',
      unreadCounts: {},
      isEscalated: null,
      isProvisional: null,
      showSearchOptions: false
    }
    this.setStatus = this.setStatus.bind(this)
    this.openSearch = this.openSearch.bind(this)
    this.closeSearch = this.closeSearch.bind(this)
    this.updateIsEscalated = this.updateIsEscalated.bind(this)
    this.updateIsProvisional = this.updateIsProvisional.bind(this)
  }

  componentDidMount() {
    this.updateUnreadCounts();
  }

  updateUnreadCounts() {
    const unreadCounts = {};
    const promises = statusValues.map(status => getUnreadCountForPurchaseOrderStatus(status));
    Promise.allSettled(promises).then(res => {
      for (let i = 0; i < statusValues.length; i++) {
        unreadCounts[statusValues[i]] = res[i].value;
      }
      this.setState({ unreadCounts })
    })
  }

  setStatus(event, value) {
    this.setState({
      status: statusValues[value]
    })
  }

  openSearch() {
    this.setState({showSearchOptions: true})
  }

  closeSearch() {
    this.setState({showSearchOptions: false})
  }
  
  updateIsEscalated(event) {
    let isEscalated = event.target.value;
    if (isEscalated === 'null') isEscalated = null;
    this.setState({
      isEscalated,
    });
  }
  
  updateIsProvisional(event) {
    let isProvisional = event.target.value;
    if (isProvisional === 'null') isProvisional = null;
    this.setState({
      isProvisional,
    });
  }

  render() {

    const { status, unreadCounts, isEscalated, isProvisional, showSearchOptions } = this.state;
    const { user } = this.props;
    const tabValue = statusValues.indexOf(status);

    return (
      <>
        <Grid item xs={12} md={12} style={{paddingBottom: '87px', position: 'relative'}}>
          <Typography style={{marginBottom: '32px'}} variant="h5">
            Purchase orders
          </Typography>
          <div style={{width: '460px', height: '64px', position: 'absolute', right: '0px', top: '-16px'}}>
            <div style={{position: 'absolute', right: '0px', top: '14px'}}>
            <ClickAwayListener onClickAway={this.closeSearch}>
              <Box sx={{ position: 'relative' }}>
              <IconButton variant="contained" onClick={this.openSearch} color="primary" aria-label="Search">
                <SearchIcon />
              </IconButton>
              { showSearchOptions && <>
                <Paper style={{position: 'absolute', 'top': '50px', right: '0px', zIndex: 999, padding: '20px'}}>
                  <PONumberSearch
                  style={{display: 'block', width: '300px', marginBottom: '40px'}}
                  onType={searchPurchaseOrdersByPoNumber}
                  nameKey='purchaseOrderNumber'
                  label='PO number'
                />
                <ContractNumberSearch
                    style={{display: 'block', width: '300px'}}
                    onType={searchPurchaseOrdersByContractNumber}
                    nameKey='contractNumber'
                    label='Contract number'
                  />
                </Paper>
              </>}
            </Box>
          </ClickAwayListener>
            </div>
          </div>
          <Paper style={{marginBottom: '16px', height: '58px', position: 'relative'}}>
            <Tabs style={{height: '58px'}} value={tabValue} onChange={this.setStatus} indicatorColor="primary" textColor="primary">
              <Tab style={{minWidth: '120px', height: '58px'}} label={<Badge badgeContent={unreadCounts.pending} color="error">Pending</Badge>} />
              <Tab style={{minWidth: '120px', height: '58px'}} label={<Badge badgeContent={unreadCounts.approved} color="error">Approved</Badge>} />
              <Tab style={{minWidth: '120px', height: '58px'}} label={<Badge badgeContent={0} color="error">Received</Badge>} />
              <Tab style={{minWidth: '120px', height: '58px'}} label={<Badge badgeContent={0} color="error">Closed</Badge>} />
              <Tab style={{minWidth: '120px', height: '58px'}} label={<Badge badgeContent={unreadCounts.rejected} color="error">Rejected</Badge>} />
              <Tab style={{minWidth: '120px', height: '58px'}} label={<Badge badgeContent={unreadCounts.canceled} color="error">Canceled</Badge>} />
            </Tabs>
            
              <div className={defs.filter} style={{right: '175px'}}>
                <FormControl fullWidth>
                  <InputLabel>Escalation status</InputLabel>
                  <Select
                    onChange={this.updateIsEscalated}
                    value={isEscalated === null ? 'null' : isEscalated}
                  >
                    <MenuItem value='null'>Any</MenuItem>
                    <MenuItem value={true}>Escalated</MenuItem>
                    <MenuItem value={false}>Not escalated</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className={defs.filter}>
                <FormControl fullWidth>
                  <InputLabel>Provisional status</InputLabel>
                  <Select
                    onChange={this.updateIsProvisional}
                    value={isProvisional === null ? 'null' : isProvisional}
                  >
                    <MenuItem value='null'>Any</MenuItem>
                    <MenuItem value={true}>Provisional</MenuItem>
                    <MenuItem value={false}>Not provisional</MenuItem>
                  </Select>
                </FormControl>
            </div>
          </Paper>
          <PurchaseOrders key={status} status={status} user={user} isEscalated={isEscalated} isProvisional={isProvisional} />
        </Grid>
        <div className={defs.actionsContainer} style={{marginTop: '32px'}}>
          <Grid xs={4} md={4} style={{marginTop: '7px', marginBottom: '7px'}} item>
            <Button
              fullWidth
              color="primary"
              variant="outlined"
              onClick={() => this.props.history.push("/purchase-orders/new")}
            >
              <AddIcon style={{fontSize: '16px', marginRight: '10px', lineHeight: '26px', display: 'inline-block', verticalAlign: 'top'}} />
              New purchase order
            </Button>
          </Grid>
        </div>
      </>
    );
  }
}
export default PurchaseOrderView;